<template>
  <b-row class="mb-2 mt-2">
    <b-col
      cols="12"
      lg="4"
      md="6"
    >
      <p class="mx-10">
        Qual leitura deseja realizar?
      </p>
      <b-form-group>
        <v-select
          v-model="formaLeitura"
          class="select-size-lg"
          label="nome"
          :options="formasLeitura"
          placeholder="Selecione o medidor..."
          @change="evt => fetchLeituras()"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      lg="4"
      md="6"
      align="left"
      class="mb-3"
    >
      <p class="mx-10">
        Qual o mês/ano de referência que será cobrado?
      </p>
      <month-picker
        lang="pt"
        @change="showDate"
      />
    </b-col>
    <b-col
      v-if="loading"
      cols="12"
      class="text-center"
    >
      <b-spinner
        variant="primary"
        label="Aguarde..."
      />
    </b-col>
    <b-col
      v-else
      cols="12"
    >
      <b-row>
        <b-col
          v-for="item in leituras"
          :key="item.unidade.id"
          cols="4"
          class="pb-1"
        >
          <b-button
            :class="['w-100']"
            :variant="item.id ? 'primary' : 'outline-primary'"
            type="submit"
            @click="goToRoute(item)"
          >
            <feather-icon
              v-if="item.id"
              icon="CheckIcon"
              size="15"
            />
            <feather-icon
              v-else
              icon="AlertTriangleIcon"
              size="15"
            />
            {{ item.unidade.descricao }}</b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import vSelect from 'vue-select'
import { BFormGroup } from 'bootstrap-vue'
import { MonthPicker } from 'vue-month-picker'

export default {
  components: {
    MonthPicker,
    vSelect,
    BFormGroup,
  },
  data() {
    return {
      page: 0,
    }
  },
  computed: {
    formasLeitura() {
      return this.$store.state.leitura.formasLeitura
    },
    leituras() {
      return this.$store.state.leitura.leituras
    },
    loading() {
      return this.$store.state.leitura.loading
    },
    formaLeitura: {
      get() {
        const forma = this.$store.state.leitura.formaLeituraEmEdicao || {}
        return this.formasLeitura && this.formasLeitura.find(f => f.id === forma.id)
      },
      set(value) {
        this.$store.commit('leitura/SET_FORMA_LEITURA_EM_EDICAO', value)
      },
    },
    referencia: {
      get() {
        return (
          this.$store.state.leitura.referenciaEmEdicao || {}
        )
      },
      set(value) {
        this.$store.commit('leitura/SET_REFERENCIA_EM_EDICAO', value)
      },
    },
  },
  created() {
    this.$store.dispatch('leitura/clearAll')
    this.$store.dispatch('leitura/fetchFormasLeitura')
  },
  methods: {
    goToRoute(item) {
      this.$store.commit('leitura/SET_LEITURA_EM_EDICAO', item)
      this.$router.push({
        path: item.id ? `/leitura/${item.id}` : '/leitura/new',
      })
    },
    showDate(date) {
      this.referencia = date
      this.fetchLeituras()
    },

    fetchLeituras() {
      if (this.formaLeitura && this.referencia) {
        this.$store.dispatch('leitura/fetchLeituras', {
          formaLeitura: this.formaLeitura.id,
          referencia: this.referencia.from,
          page: this.page,
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.month-picker__month {
  border: 3px solid rgba(245, 245, 245, 0.75);
  flex-basis: calc(33.333% - 1px);
}
</style>
